export default "/assets/images/mila-valentine-mobile-b-w.webp?5e491aa845fc2c83245f8ef2b6581841";